var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Modal as StandardModal } from "react-bootstrap/lib";
import padding from "@irati/ui/src/global/padding";
import CloseBase from "@irati/ui/src/Close";
import { IconButton } from "@irati/ui/src/Button";
export var ImageModal = styled(StandardModal)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .modal-content{\n    ", "\n  }\n"], ["\n  .modal-content{\n    ", "\n  }\n"])), function (_a) {
    var margintop = _a.margintop;
    return margintop && "margin-top: " + margintop + "px;";
});
export var ModalInner = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: ", ";\n  padding-top: 40px;\n  ", "\n"], ["\n  padding: ", ";\n  padding-top: 40px;\n  ",
    "\n"])), padding.small, function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), padding.medium);
});
export var Close = styled(CloseBase)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  top: 10px;\n  right: 10px;\n  ", "\n"], ["\n  top: 10px;\n  right: 10px;\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    top: 20px;\n    right: 20px;\n  "], ["\n    top: 20px;\n    right: 20px;\n  "])));
});
export var Back = styled(IconButton)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  ", "\n"], ["\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.mediaQueries.minWidthMedia.tablet(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    top: 20px;\n    left: 20px;\n  "], ["\n    top: 20px;\n    left: 20px;\n  "])));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
